// import { toCSS, toJSON } from 'cssjson';

export const generatePreloader = (styles: object) => {
  const { preloader }: { preloader?: any } = styles;

  const str = `.default-preloader {
    position:relative;
    width:${preloader.size}px;
    height:${preloader.size}px;
    transform:translateZ(0);
    font-size:${preloader.thickness}px;
    text-indent:-9999em;
    border-top:${preloader.thickness}px solid #8C9BB020;
    border-right:${preloader.thickness}px solid #8C9BB020;
    border-bottom:${preloader.thickness}px solid #8C9BB020;
    border-left:${preloader.thickness}px solid ${preloader.color};
    animation:svg-ring ${1 / preloader.speed}s cubic-bezier(0.5,0,0.5,1) infinite;}`;

  /* redunant code? */
  // const json = toJSON(str);
  // const css = toCSS(json);
  /* end of redunant code */

  return str;
};
